// extracted by mini-css-extract-plugin
export default {"mt":"TandCView_mt__ctwFC"};